// A status captures a reason when layer_status_labels_v2.reasons has an entry
// for it (the same list the layer-level reason offers). An empty entry still
// captures one, through "Add New" alone.
export const reasonsForStatus = (statusLabels, status) => {
  const reasons = status == null ? null : statusLabels?.reasons?.[status];
  return Array.isArray(reasons) ? reasons : null;
};

// The reason shows while the status captures one, and also while one is
// recorded, so a recorded reason can still be seen and cleared.
export const isReasonShown = (statusLabels, status, value) =>
  reasonsForStatus(statusLabels, status) != null || value != null;

// Configured reasons are stored by key and shown by name. A reason added on
// the submission is stored as typed, so it shows as typed.
export const reasonDisplayName = (reasons, value) =>
  (reasons ?? []).find((reason) => reason.reasonKey === value)?.displayName ??
  value;

// The configured reasons by name, plus the selected one when it was added on
// the submission, so it can still be seen in the list.
export const reasonOptions = (reasons, selected) => {
  const options = (reasons ?? [])
    .map((reason) => reason.displayName)
    .filter((name) => !!name);
  return selected != null && !options.includes(selected)
    ? [...options, selected]
    : options;
};

// Matches the typed text anywhere in a name, ignoring case, and offers to add
// it as a new reason unless it is already listed.
export const filterReasonOptions = (choices, text) => {
  const inputValue = (text ?? "").trim();
  const lowered = inputValue.toLowerCase();
  const filtered = choices.filter((choice) =>
    choice.toLowerCase().includes(lowered)
  );
  const isListed = choices.some((choice) => choice.toLowerCase() === lowered);
  return inputValue && !isListed
    ? [...filtered, { addNew: true, value: inputValue }]
    : filtered;
};

export const reasonValue = (reasons, text) => {
  const trimmed = (text ?? "").trim();
  if (!trimmed) {
    return null;
  }
  const match = (reasons ?? []).find(
    (reason) =>
      reason.reasonKey === trimmed ||
      reason.displayName?.toLowerCase() === trimmed.toLowerCase()
  );
  return match ? match.reasonKey : trimmed;
};
